import useGetPaymentSummary from './useGetPaymentSummary';

export default function useCanFinance() {
  const {
    totals: { totalPrice = 0 }
  } = useGetPaymentSummary();

  return totalPrice >= 1000;
}
